<!-- 扫码后的抽奖页面 -->
<template>
  <div class='award-container'>
    <div class="content-wrapper">
      <div class="avatar-wrapper">
        <img :src="qrcode.product ? qrcode.product.cover : ''" alt="" />
      </div>
      <div v-if="qrcode.product" class="text-wrapper">
        <p>您购买的是国花瓷西凤酒</p>
        <p>{{qrcode.product.short_name ? qrcode.product.short_name : qrcode.product.name}}</p>
        <block v-if="!qrcode.fake">
          <p>这是第{{qrcode.scan_count}}次验证，请您放心饮用</p>
        </block>
        <block v-else>
          <p>这是第{{qrcode.scan_count}}次验证，防伪查询次数过多</p>
          <p>请谨防假冒产品，如果疑问可<a href="tel://4000039990">拨打400电话</a></p>
        </block>
      </div>
      <div v-if="awardLog || qrcode.awarded" class="btn-wrapper-1" @click="toStore">
        <img src="../assets/img/award/btn_jfsc.png" alt="" />
      </div>
      <div v-else class="btn-wrapper" @click="drawAward">
        <img src="../assets/img/award/btn_choujiang.png" alt="" />
      </div>
    </div>
    <div class="side-wrapper" @click="toAward">
      <p>我的奖品</p>
    </div>
    <div class="footer-wrapper">
      <div class="warning-text">
        <p>本页面含有酒水内容 未满18岁敬请回避</p>
        <p>国花瓷温馨提示：未满18岁禁止饮酒</p>
      </div>
      <div class="copyright-text">
        <p>版权所有：国花瓷 | 技术支持：树云科技</p>
      </div>
    </div>
    <van-popup class="popup-wrapper" :close-on-click-overlay="false" v-model="showPopup">
      <div class="content-wrapper">
        <div class="success-img">
          <img src="../assets/img/award/btn_gongxi.png" />
        </div>
        <div class="text-wrapper">
          <p v-if="awardLog">获得【{{awardLog.award_name}}】</p>
          <div @click="takeAward" class="content-btn">
            <img src="../assets/img/award/btn_lingqu.png" />
          </div>
        </div>
      </div>
      <div class="close-wrapper" @click="closePopup">
        <img src="../assets/img/award/close.png" />
      </div>
    </van-popup>
    <van-popup class="popup-small-wrapper" :close-on-click-overlay="false" v-model="showPopupSmall">
      <div class="content-wrapper">
        <div class="error-wrapper">
          <p>{{errorTitle}}</p>
          <div @click="toStore" class="error-btn">
            <img src="../assets/img/award/btn_jfsc.png" />
          </div>
        </div>
      </div>

      <div class="close-wrapper" @click="closePopup">
        <img src="../assets/img/award/close.png" />
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import qs from 'qs'
import Config from '@/config/config'

import { Toast, NoticeBar, Dialog, Popup } from 'vant'
Vue.use(Dialog).use(Toast).use(NoticeBar).use(Popup)

export default {
  name: 'Award',
  data() {
    return {
      awardLog: null,
      errorTitle: '',
      serial: '',
      showPopupSmall: false,
      showPopup: false,
      canDrawAward: true,
      isNotAwarded: false,
      canRequest: true
    }
  },

  mounted() {
    this.init()
  },
  created() {
    this.serial = this.$route.query.serial
  },

  computed: {
    ...mapGetters(['userInfo', 'location', 'qrcode', 'subscribe'])
  },
  methods: {
    /**
     * 初始化
     * 判断是否还能够抽奖
     */
    init() {
      // 未关注公众号先去关注
      // if (!this.subscribe) {
      /* eslint-disable no-constant-condition */
      if (false) {
        return Dialog.alert({
          message: '请先关注公众号再领奖'
        }).then(() => {
          return this.$router.push({ name: 'Subscribe' })
        })
      }
      if (this.qrcode.awarded) {
        this.showPopupSmall = true
        this.errorTitle = '该瓶酒已抽过奖'
      }
    },
    /**
     * 抽奖
     */
    drawAward() {
      var that = this
      const params = {
        serial: that.serial,
        latitude: that.location.latitude,
        longitude: that.location.longitude,
        province: that.location.province,
        city: that.location.city,
        district: that.location.district,
        location: that.location.address,
        province_code: that.location.province_code,
        city_code: that.location.city_code,
        district_code: that.location.district_code
      }
      that.axios.post('/activity/award/draw/', qs.stringify(params)).then(function(res) {
        console.log(res)
        if (res.code === 3000) {
          that.errorTitle = '谢谢惠顾'
          that.showPopupSmall = true
        }
        if (res.code === 4000) {
          // 设置已抽奖
          that.$store.dispatch('setAwarded')
          that.awardLog = res.data
          that.showPopup = true
        } else if (res.code === 4001) {
          that.errorTitle = '该瓶酒已抽过奖'
          that.showPopupSmall = true
        } else if (res.code === 4002) {
          that.isNotAwarded = true
          that.errorTitle = '谢谢惠顾'
          that.showPopupSmall = true
        } else if (res.code === 500) {
          Toast(res.message)
        }
      }).catch(function(error) {
        console.log(error)
        that.$router.push({ name: 'QrcodeError', params: { errMsg: '系统错误' }})
      })
    },
    /**
     * 领取奖品
     * 如果奖品是红包，直接请求接口领取；如果奖品是实物，进到领奖页面
     * TODO 增加领取积分
     */
    takeAward() {
      // 防止重复点击
      if (!this.canRequest) {
        return
      }
      if (this.awardLog.award_type === 0) {
        this.$router.push({ path: '/user/award/receive', query: { logId: this.awardLog.id }})
        // 实物奖
      } else if (this.awardLog.award_type === 1) {
        // 领取虚拟奖品
        window.location.href = this.awardLog.award_url
      } else if (this.awardLog.award_type === 2) {
        // 红包
        var that = this
        this.canRequest = false
        var params = {
          id: this.awardLog.id
        }
        this.axios.post('/activity/award/receive/', qs.stringify(params)).then(function(res) {
          that.canRequest = true
          if (!res.code) {
            Dialog.alert({
              title: '提示',
              message: '红包已发放，请到微信消息里领取'
            }).then(() => {
              // 领取后跳转到积分商城
              if (this.userInfo.id) {
                const storeUrl = Config.creditStoreBaseUrl + '/?name=' + that.userInfo.nickname + '&gender=' + that.userInfo.gender +
                '&province=' + that.userInfo.province + '&city=' + that.userInfo.city + '&avatar=' + that.userInfo.avatar +
                '&userCode=' + that.userInfo.openid + '&appId=' + Config.creditStoreAppId + '&phone=' + that.userInfo.mobile
                window.location.href = storeUrl
              } else {
                that.$router.push({ path: '/' })
              }
            })
          } else {
            Toast(res.message)
          }
        }).catch(function(error) {
          console.log(error)
          that.canRequest = true
          Toast('红包领取失败')
        })
      } else {
        // TODO 增加积分领取
      }
    },
    /**
     * 关闭弹窗
     */
    closePopup() {
      this.showPopup = false
      this.showPopupSmall = false
    },
    /**
     * 跳转到积分商城
     */
    toStore() {
      if (this.userInfo.id) {
        const storeUrl = Config.creditStoreBaseUrl + '/?name=' + this.userInfo.nickname + '&gender=' + this.userInfo.gender +
        '&province=' + this.userInfo.province + '&city=' + this.userInfo.city + '&avatar=' + this.userInfo.avatar +
        '&userCode=' + this.userInfo.openid + '&appId=' + Config.creditStoreAppId + '&phone=' + this.userInfo.mobile
        window.location.href = storeUrl
      } else {
        this.$router.push({ path: '/' })
      }
    },
    /**
     * 跳转到中奖记录
     */
    toAward() {
      console.log('toaward')
      this.$router.push({ path: '/user/award/log' })
    }
  }
}
</script>

<style lang="scss" scoped>
.award-container {
  width: 100%;
  height: 100%;
  background: #fff7ec;
  position: relative;
  .content-wrapper {
    width: 375px;
    position: relative;
    z-index: 10;
    .avatar-wrapper {
      width: 100px;
      height: 100px;
      position: relative;
      top: 30px;
      margin: 0 auto;
      background-image: url('../assets/img/award/avatar_bg.png');
      background-size: 100% 100%;
      img {
        width: 80px;
        height: 80px;
        margin: 10px;
        border-radius: 40px;
      }
    }
    .text-wrapper {
      position: relative;
      top: 50px;
      width: 100%;
      text-align: center;
      color: #07478C;
      font-size: 14px;
      p {
        height: 25px;
        line-height: 25px;
        font-weight: bold;
      }
    }
    .btn-wrapper {
      position: relative;
      top: 70px;
      width: 200px;
      height: 32px;
      margin: 0 auto;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .btn-wrapper-1 {
      position: relative;
      top: 65px;
      width: 150px;
      height: 30px;
      margin: 0 auto;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .side-wrapper {
    position: fixed;
    width: 50px;
    height: 40px;
    padding: 0 7px 0 7px;
    border-radius: 100px 0 0 100px;
    box-sizing: border-box;
    right: 0;
    top: 80px;
    z-index: 100;
    background-color: #07478c;
    p {
      color: #fff;
      width: 42px;
      font-size: 12px;
      place-content: center;
      letter-spacing: 3px;
      padding: 6.5px;
    }
  }
  .footer-wrapper {
    width: 375px;
    height: 500px;
    background-image: url('../assets/img/award/img_bg.png');
    background-size: 100% 100%;
    position: fixed;
    bottom: 0;
    .warning-text {
      position: absolute;
      bottom: 60px;
      height: 40px;
    }
    .copyright-text {
      position: absolute;
      bottom: 20px;
      height: 20px;
    }
    p {
      width: 375px;
      text-align: center;
      font-size: 14px;
      color: #fff;
      height: 20px;
      line-height: 20px;
    }
  }
  .popup-wrapper {
    width: 275px;
    height: 342px;
    background-color: unset;
    .content-wrapper {
      width: 275px;
      height: 282px;
      background-image: url('../assets/img/award/dialog.png');
      background-size: 100% 100%;
      background-color: unset;
      position: relative;
      .success-img {
        width: 140px;
        height: 45px;
        margin: 0 auto;
        position: relative;
        top: 60px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .text-wrapper {
        width: 275px;
        text-align: center;
        color: #fff;
        position: relative;
        top: 100px;
        p {
          font-size: 14px;
          height: 25px;
          line-height: 25px;
          font-weight: bold;
        }
        .content-btn {
          width: 160px;
          height: 34px;
          position: relative;
          margin: 0 auto;
          top: 50px;
          img {
            width: 150px;
            height: 27px;
          }
        }
      }
    }
    .close-wrapper {
      position: absolute;
      z-index: 100;
      bottom: 10px;
      width: 275px;
      text-align: center;
      img {
        width: 25px;
        height: 25px;
      }
    }
  }
  .popup-small-wrapper {
    width: 275px;
    height: 268px;
    background-color: unset;
    .content-wrapper {
      width: 275px;
      height: 208px;
      background-image: url('../assets/img/award/dialog_small.png');
      background-size: 100% 100%;
      background-color: unset;
      position: relative;
      .error-wrapper {
        width: 275px;
        text-align: center;
        color: #fff;
        position: relative;
        top: 70px;
        p {
          font-size: 14px;
          height: 25px;
          line-height: 25px;
          font-weight: bold;
        }
        .error-btn {
          width: 150px;
          height: 30px;
          position: relative;
          margin: 0 auto;
          top: 50px;
          img {
            width: 150px;
            height: 30px;
          }
        }
      }
    }
    .close-wrapper {
      position: absolute;
      z-index: 100;
      bottom: 10px;
      width: 275px;
      text-align: center;
      img {
        width: 25px;
        height: 25px;
      }
    }
  }
}
</style>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/award.vue